// extracted by mini-css-extract-plugin
export var numpadContainer = "_py-1";
export var phoneButton = "_py-0";